import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 5E21DB8A-BFFC-4038-8EBF-D3E462A43CD9
 * name signal-cellular-2
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signal-cellular-2.svg
 * tags
 * - Cellphone / Phone 
 */
export const SignalCellular2Icon = createSvgIcon(<><path d="M19.5,5.5V18.5H17.5V5.5H19.5M21,4H16V20H21V4M14,9H9V20H14V9M7,14H2V20H7V14Z" /></>, 'SignalCellular2Icon');
export default SignalCellular2Icon